<template>
  <div>
    <svg id="tracker" width="800" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <rect v-for="(style, index) in dayStyles" track-by="index" v-bind:x="index * 12" y="0" height="10" width="10" rx="2" ry="2" v-bind:class="style"/>
    </svg>
  </div>
</template>

<style scoped>
rect {
  stroke: #cccccc;
}
rect.present {
  fill: green;
}
rect.missing {
  fill: red;
}
</style>

<script>
import moment from 'moment'

export default {
  $el () {
    return '#el'
  },

  data () {
    return {
    }
  },

  props: {
    dateStart: {
      type: String,
      required: true,
      default: () => ('')
    },
    dateEnd: {
      type: String,
      required: true,
      default: () => ('')
    },
    days: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },

  computed: {
    trackDays () {
      var trackDays = []
      var date = moment(this.dateStart, 'x')

      do {
        trackDays[date.format('YYYYMMDD')] = 0
        date = date.add(1, 'day')
      }
      while (date.format('x') < this.dateEnd)

      return trackDays
    },

    dayStyles () {
      var date, keys, i
      var dayStyles = []

      for (i = 0; i < this.days.length; i++) {
        date = moment(this.days[i].range).format('YYYYMMDD')
        // console.log('considering date', date, this.days[i].range)
        if (date in this.trackDays) {
          this.trackDays[date] = 1
        }
      }

      // build the string representation
      keys = Object.keys(this.trackDays).sort()
      for (i = 0; i < keys.length; i++) {
        dayStyles.push(this.trackDays[keys[i]] === 1 ? 'present' : 'missing')
      }

      return dayStyles
    }
  }
}
</script>



// WEBPACK FOOTER //
// TrackDays.vue?2f771939